module.exports = __webpack_public_path__ + "img/lixeira.1c044ba1.svg";